define('plugin/pwa/model/PwaModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * PWA Model
     *
     * @class PwaModel
     */
    return BaseModel.extend({

        //url: '/ext/pwa/',
        registerPushUrl: '/ext/pwa/register-push',

        defaults: {
            is_subcribed: true
        },

        // clear: function () {
        //     var url = this.baseUrl + '/ext/pwa/clear/';
        //     Backbone.ajax(url, {
        //         success: _.bind(function () {
        //             this.trigger('sync');
        //         }, this)
        //     });
        // }

        registerPush : function (token, options, callback) {
            var _this = this;

            if(options && typeof options == 'function' && !callback){
                callback = options;
                options = {};
            }

            Backbone.ajax({
                url: this.baseUrl + this.registerPushUrl,
                //dataType : 'json',
                type : 'POST',
                data : _.extend({
                    token: token,
                }, options),
            }).success(function(data) {
                if(typeof callback == 'function'){
                    callback(data);
                }
            });
        }
    });

});
